import { useNavigate } from 'react-router-dom';
import { FallbackProps } from 'react-error-boundary';
import { Button } from '@antimatterhq/ui/components/button';
import { Text } from '@antimatterhq/ui/components/typography';
import { Trend } from '@antimatterhq/ui/components/trend';
import { BaseHomepageSummaryCard } from '@/components/homepage/summaryCard/BaseHomepageSummaryCard';
import { HomepageSummaryCardMainMetric } from '@/components/homepage/summaryCard/HomepageSummaryCardMainMetric';
import { useGetNotablesSummary } from '@/hooks/dbui/useGetNotablesSummary';
import { DefaultErrorBoundaryFallback } from '@/components/errorBoundary/ErrorBoundary';
import HomepageSummaryCardSkeleton from '@/pages/home/_partials/HomepageSummaryCardSkeleton';

export const NotablesHomepageSummaryCard = () => {
  const { data } = useGetNotablesSummary();
  const navigate = useNavigate();

  return (
    <BaseHomepageSummaryCard title="Notables" to={'/explore/notables'}>
      <div className="grid grid-cols-3 gap-4">
        <HomepageSummaryCardMainMetric
          label="Open notables"
          value={data?.currentlyOpen}
        />
        <Trend
          label="Total new last 7 days"
          value={data?.notablesLast7days}
          trend={{
            startingValue: data?.notablesPreceding7days ?? 0,
            endingValue: data?.notablesLast7days ?? 0,
          }}
          summarizeCount
        />
        <Trend
          label="Total new last 24 hours"
          value={data?.notablesLast24hours}
          trend={{
            startingValue: data?.notablesPreceding24hours ?? 0,
            endingValue: data?.notablesLast24hours ?? 0,
          }}
          summarizeCount
        />
      </div>
      <div className="mt-4 flex w-full justify-between">
        <div className="flex flex-col">
          <div className="flex items-center gap-2">
            <Text size="2xl" bold className="text-red-600 dark:text-red-600">
              {data?.currentlyUnassigned}
            </Text>
            <Text>Unassigned</Text>
          </div>
        </div>
        <Button
          variant="default"
          leftIcon="lucide:folder-open"
          onClick={() => navigate('/explore/notables')}
        >
          View open tickets
        </Button>
      </div>
    </BaseHomepageSummaryCard>
  );
};

export const NotablesHomepageSummaryCardSkeleton = () => (
  <HomepageSummaryCardSkeleton
    title="Notables"
    subtitle="Open notables"
    to="/explore/notables"
    showStatus
    showActionButton
    actionButtonText="View open notables"
    totalsMetric="new"
  />
);

export const NotablesHomepageSummaryCardErrorFallback = (
  props: FallbackProps,
) => {
  return (
    <BaseHomepageSummaryCard title="Notables" to="/explore/notables">
      <DefaultErrorBoundaryFallback {...props} />
    </BaseHomepageSummaryCard>
  );
};
